import React from 'react';
import { useParams } from 'react-router-dom';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import GroupSelector, { useGroupSelector } from 'modules/groups/components/GroupSelector';

import LessonsStatsTable from '../../components/LessonsStatsTable';
import { useLessonsStats } from '../../hooks';

const useStyles = makeStyles((theme) => ({
  groupSelector: {
    width: 200,
    marginBottom: theme.spacing(2),
  },
}));

const AttendanceStatsPage = () => {
  const classes = useStyles();
  const { courseId } = useParams();

  const { props: groupSelectorProps, selectedGroup } = useGroupSelector({
    courseId,
  });

  const groupId = selectedGroup?._id;

  const { lessonsStats, loading, error } = useLessonsStats({
    courseId,
    groupId,
  });

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end">
        <GroupSelector {...groupSelectorProps} className={classes.groupSelector} />
      </Box>
      <LessonsStatsTable lessonsStats={lessonsStats} loading={loading} error={error} />
    </Box>
  );
};

export default AttendanceStatsPage;
